import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { MicroLabel } from './micro-label';

/**
 * Shown by every route that exists in navigation but has no mockup yet
 * (docs/FRONTEND_REBUILD.md section 6). Those routes stay visible and clickable on purpose -
 * navigation must look complete - so this is what they land on.
 */
export function EmptyState({
  title,
  note,
  icon,
  className
}: {
  title: string;
  note?: string;
  icon?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'grid place-items-center rounded border border-dashed border-border bg-card px-6 py-20 text-center',
        className
      )}
    >
      <div className="grid justify-items-center gap-3">
        {icon ? <div className="text-dim">{icon}</div> : null}
        <p className="text-[15px] text-muted">{title}</p>
        {note ? <MicroLabel size="xs">{note}</MicroLabel> : null}
      </div>
    </div>
  );
}
